const APP_CHECK_INVALID_CODE = 'app_check_invalid'

interface AppCheckServerError {
  statusCode?: number
  result?: {
    errors?: Array<{ code?: string }>
  }
}

type Listener = () => void

export const AppCheckRecoveryStatus = {
  Idle: 'idle',
  Recovering: 'recovering',
  Required: 'required',
} as const

type AppCheckRecoveryStatusValue = typeof AppCheckRecoveryStatus[keyof typeof AppCheckRecoveryStatus]

let recoveryStatus: AppCheckRecoveryStatusValue = AppCheckRecoveryStatus.Idle
const listeners = new Set<Listener>()

const isAppCheckRejection = (error: unknown): boolean => {
  const serverError = error as AppCheckServerError | null

  return (
    serverError?.statusCode === 403 &&
    serverError.result?.errors?.some(({ code }) => code === APP_CHECK_INVALID_CODE) === true
  )
}

const setRecoveryStatus = (status: AppCheckRecoveryStatusValue) => {
  if (recoveryStatus === status) {
    return
  }

  recoveryStatus = status
  listeners.forEach((listener) => listener())
}

const startRecovery = () => {
  if (recoveryStatus === AppCheckRecoveryStatus.Idle) {
    setRecoveryStatus(AppCheckRecoveryStatus.Recovering)
  }
}

const requireRecovery = () => setRecoveryStatus(AppCheckRecoveryStatus.Required)

const clearRecovery = () => setRecoveryStatus(AppCheckRecoveryStatus.Idle)

const subscribe = (listener: Listener) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = () => recoveryStatus

export default {
  clearRecovery,
  getSnapshot,
  isAppCheckRejection,
  requireRecovery,
  startRecovery,
  subscribe,
}
